import React from 'react';
import { withRouter } from 'react-router-dom';
import Header from 'components/Header';
import Message from 'components/Message';
import CancelGoButtons from 'components/CancelGoButtons';
import ContainerFixedFab from 'ui/ContainerFixedFab';
import { Button, Icon } from 'semantic-ui-react';
import BillCard from './ui/BillCard';
import API from 'utils/api';
import { displayTitle, hasBillLabel } from 'utils/billDisplay';

class BillsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bills: [],
      isFabActive: false,
      showDeleteConfirmation: false,
      billToDelete: null
    };
  }

  componentDidMount() {
    this.getBills();
  }

  getBills = () => {
    API.getBills()
      .then((response) => {
        this.setState({ bills: response.data });
      })
      .catch((error) => {
        console.error(error);
      });
  }

  createBill = () => {
    // Add active state briefly when clicked
    this.setState({ isFabActive: true });
    setTimeout(() => {
      this.setState({ isFabActive: false });
    }, 200);
    
    const params = {};

    API.createBill(params)
      .then((response) => {
        const newBill = response.data;
        this.props.history.push(`/bills/${newBill.id}`);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  handleDeleteClick = (billId) => {
    this.setState({
      showDeleteConfirmation: true,
      billToDelete: billId
    });
  }

  handleConfirmDelete = () => {
    const { billToDelete } = this.state;
    
    if (billToDelete) {
      API.deleteBill(billToDelete)
        .then(() => {
          // Remove the bill from state
          this.setState(prevState => ({
            bills: prevState.bills.filter(bill => bill.id !== billToDelete),
            showDeleteConfirmation: false,
            billToDelete: null
          }));
        })
        .catch((error) => {
          console.error(error);
          this.setState({
            showDeleteConfirmation: false,
            billToDelete: null
          });
        });
    }
  }

  handleCancelDelete = () => {
    this.setState({
      showDeleteConfirmation: false,
      billToDelete: null
    });
  }

  render() {
    if (!this.state.bills) { return null }

    // Show delete confirmation page
    if (this.state.showDeleteConfirmation) {
      const bill = this.state.bills.find(b => b.id === this.state.billToDelete);
      if (!bill) return null;
      
      return (
        <div style={{ marginTop: '1em' }}>
          <Message headerText="Eliminar cuenta">
            <p style={{ textAlign: 'center', fontSize: '1.2em', marginBottom: '1.5em' }}>
              ¿Estás seguro de eliminar esta cuenta?
            </p>
            
            <p style={{ textAlign: 'center', fontSize: '1.2em', marginBottom: '1.5em' }}>
              <b>{displayTitle(bill)}</b>
              {hasBillLabel(bill) && (
                <span style={{ display: 'block', fontSize: '0.85em', color: '#666', marginTop: '0.35em', fontWeight: 'normal' }}>
                  ID #{bill.id}
                </span>
              )}
            </p>

            <p style={{ textAlign: 'center', color: '#666', fontSize: '1em', marginBottom: '1.5em' }}>
              Esta acción no se puede deshacer.
            </p>
  
            <CancelGoButtons
              cancelFn={this.handleCancelDelete}
              cancelText="Cancelar"
              goText="Eliminar cuenta"
              goEnabled={true}
              goFn={this.handleConfirmDelete}
              warning={true}
            />
          </Message>
        </div>
      );
    }

    let content = null;
    
    if (this.state.bills.length === 0) {
      content = (
        <Message>
          Aún no tienes cuentas abiertas. Dale click al botón de "+" para abrir una cuenta nueva.
        </Message>
      );
    }
    
    const { isFabActive } = this.state;
    
    const fabStyle = {
      width: '56px',
      height: '56px',
      borderRadius: '50%',
      boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      transition: 'all 0.15s ease-in-out',
      transform: isFabActive ? 'scale(0.95)' : 'scale(1)'
    };
    
    return (
      <div>
        <Header text="Tus Cuentas Abiertas" />

        { content }

        <div>
          { this.state.bills.map((bill) => {
            return (
              <BillCard 
                bill={bill} 
                key={bill.id} 
                onDelete={this.handleDeleteClick}
              />
            )
          })}
        </div>
        
        <ContainerFixedFab>
          <Button
            circular
            primary
            icon
            style={fabStyle}
            onClick={this.createBill}
          >
            <Icon name='plus' size="large" />
          </Button>
        </ContainerFixedFab>
      </div>
    )
  }
}

export default withRouter(BillsPage);